var TabTasksModule = /** @class */ (function () {
    function TabTasksModule() {
    }
    return TabTasksModule;
}());
export { TabTasksModule };
